import React, { useEffect, useMemo } from "react";
import { getAvailableFonts } from "@remotion/google-fonts";

function MultilineView({ element, getPropertyByStyleKey, getValueByKey }) {
  const fonts = getAvailableFonts();
  const style = useMemo(
    () => ({
      color:
        element?.style?.color?.value ||
        getPropertyByStyleKey(element?.style?.color?.key),
      fontSize: element?.style?.fontSize?.value || "16px",
      backgroundColor:
        element?.style?.backgroundColor?.value ||
        getPropertyByStyleKey(element?.style?.backgroundColor?.key),
      fontWeight: element?.style?.fontWeight?.value || "normal",
      textAlign: element?.style?.textAlign?.value || "left",
      fontStyle: element?.style?.fontStyle?.value || "normal",
      fontFamily:
        element?.style?.fontFamily?.value ||
        getPropertyByStyleKey(element?.style?.fontFamily?.key),
      ...(element?.style?.lineHeight?.value
        ? { lineHeight: element.style.lineHeight.value }
        : {}),
    }),
    [element?.style, getPropertyByStyleKey]
  );

  useEffect(() => {
    let fontsBeingUsed = style.fontFamily;
    if (!fontsBeingUsed) {
      return;
    }

    let fontObject = fonts.find((f) => f.fontFamily === fontsBeingUsed);
    if (fontObject) {
      fontObject.load().then((l) => {
        l.loadFont();
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [style]);

  const getVaue = () => {
    if (typeof element.value === "string") {
      return element.value;
    }
    if (typeof element.value === "object") {
      return getValueByKey(element.value.key);
    }
  };
  return (
    <div
      className={"whitespace-pre-wrap " + (element.className || "")}
      style={style}
    >
      {getVaue()}
    </div>
  );
}

export default MultilineView;
